import React, { useState } from 'react'
import moment from 'moment'
import {
  Alert,
  AlertTitle,
  Autocomplete,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import AnDateTimePicker from '../../../../../components/DateTime/DateTimePicker'
import AssessmentText from '../AssessmentText'

const MentalCapacity = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  const capacitySteps = [
    'With all possible help given, is the person able to understand the information relevant to the decision?',
    'Are they able to retain the information long enough to make the decision?',
    'Are they able to weigh up the information as part of the decision making process',
    'Are they able to communicate the decision?',
  ]

  return (
    <Stack gap={2} padding={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">Mental Capacity Assessment</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            size="small"
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <FormControl fullWidth>
            <InputLabel>Does a decision need to be made?</InputLabel>
            <Select
              value={moduleValues?.['Decision to be made'] ?? ''}
              label="Does a decision need to be made?"
              onChange={(e) =>
                setModuleValues((prev) => ({
                  ...prev,
                  'Decision to be made': e.target.value,
                }))
              }
            >
              <MenuItem value="Yes">Yes</MenuItem>
              <MenuItem value="No">No</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {moduleValues?.['Decision to be made'] === 'No' ? (
          <Grid item xs={12}>
            <Alert severity="error">
              <AlertTitle>End of Process</AlertTitle>The Mental Capacity Act is
              decision and time specific
            </Alert>
          </Grid>
        ) : (
          <>
            <Grid item xs={12} lg={8}>
              <FormControl fullWidth>
                <InputLabel>
                  Is there an impairment or disturbance in the functioning of
                  mind or brain?
                </InputLabel>
                <Select
                  value={moduleValues?.['Impairment or Disturbance'] ?? ''}
                  label="Is there an impairment or disturbance in the functioning of
                  mind or brain?"
                  onChange={(e) =>
                    setModuleValues((prev) => ({
                      ...prev,
                      'Impairment or Disturbance': e.target.value,
                    }))
                  }
                >
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {moduleValues?.['Impairment or Disturbance'] === 'No' ? (
              <Grid item xs={12}>
                <Alert severity="error">
                  <AlertTitle>Impairment is not present</AlertTitle>Record
                  refusal and arrange safety netting, the patient is deemed
                  capable.
                </Alert>
              </Grid>
            ) : (
              <>
                {capacitySteps.map((step, index) => (
                  <Grid item xs={12} key={index}>
                    <FormControl fullWidth>
                      <InputLabel>{step}</InputLabel>
                      <Select
                        value={moduleValues?.[step] ?? ''}
                        label={step}
                        onChange={(e) =>
                          setModuleValues((prev) => ({
                            ...prev,
                            [step]: e.target.value,
                          }))
                        }
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                ))}
              </>
            )}
          </>
        )}
        <AssessmentText
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <Grid item xs={12}>
          <Button
            onClick={() => submitModule('Mental Capacity', moduleValues)}
            variant="contained"
            fullWidth
            color="success"
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </Stack>
  )
}

export default MentalCapacity
